export const DASHBOARD_TYPE = {
  personal: 'personal',
  global: 'global',
} as const;

export const HEATMAP_FOLDER_ITEM_ID = 'heatmap_folder'
export const HEATMAP_TAB_TITLE = 'Heatmap';